import { useState, useContext } from 'react';
import GithubContext from '../context/github/GithubContext';
import AlertContext from '../context/alert/AlertContext';
import { searchUsers } from '../context/github/GithubActions';

function UserSearch() {
  const { users, dispatch } = useContext(GithubContext);
  const { setAlert } = useContext(AlertContext);

  const [text, setText] = useState('');

  const handleChange = (event) => {
    console.log(event.target.value);
    setText(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (text === '') {
      //   alert('Please enter something');
      setAlert('Please enter something', 'error');
    } else {
      // search users
      dispatch({ type: 'SET_LOADING' });
      const users = await searchUsers(text);
      dispatch({ type: 'GET_USERS', payload: users });
      setText('');
    }
  };

  const handleClear = () => {
    // clearUsers()
    dispatch({ type: 'CLEAR_USERS' });
  };

  return (
    <div className='grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 mb-8 gap-8'>
      <div>
        <form onSubmit={handleSubmit}>
          <div className='form-control'>
            <div className='relative'>
              <input
                type='text'
                className='w-full pr-40 bg-gray-200 input input-lg text-black'
                placeholder='Search'
                value={text}
                onChange={handleChange}
              />
              <button
                className='absolute top-0 right-0 rounded-l-none w-36 btn btn-lg'
                type='submit'
              >
                Go
              </button>
            </div>
          </div>
        </form>
      </div>

      {users.length > 0 && (
        <div>
          <button className='btn btn-ghost btn-lg' onClick={handleClear}>
            clear
          </button>
        </div>
      )}
    </div>
  );
}

export default UserSearch;
